import React, { useEffect, useState } from 'react';

// IMPORT DEPENDENCIES
import { Link, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteKuryeService, deleteKuryeDataCancel } from '../../actions/admin/admin';

//IMPORT COMPONENT
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import Loader from '../../components/loader/loader';

const DeleteKurye = () => {

    const Dispatch = useDispatch();

    const token = useSelector(state => state.AuthReducer.token);
    const deletekuryestatus = useSelector(state => state.AdminReducer.deletekuryestatus);
    const kuryedeletedata = useSelector(state => state.AdminReducer.kuryedeletedata);
    const loading = useSelector(state => state.AdminReducer.loading);

    useEffect(() => {
        Dispatch(deleteKuryeDataCancel());
    }, []);

    const [name, setName] = useState(kuryedeletedata.name);
    const [surname, setSurname] = useState(kuryedeletedata.surname);
    const [cuzdan, setCuzdan] = useState(kuryedeletedata.cuzdan);
    const [tel, setTel] = useState(kuryedeletedata.telephone);
    const [sehir,setSehir]=useState(kuryedeletedata.sehir)
    const [error, setError] = useState(false);

    const handleCuzdan = (e) => {
        setCuzdan(e.target.value)
        setError(false);
    }
    const handleName = (e) => {
        setName(e.target.value);
        setError(false);
    }
    const handleSurname = (e) => {
        setSurname(e.target.value);
        setError(false);
    }
    const handleTel = (e) => {
        setTel(e.target.value);
        setError(false);
    }

    const handleSehir = (e) => {
        setSehir(e.target.value)
        setError(false);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (name !== '' && surname !== 0 && name.trim() !== '' && surname.trim() !== '' && cuzdan !== '' && cuzdan.trim() !== '' && tel !== '' && tel.trim() !== '' && sehir!=='null' ) {
            Dispatch(deleteKuryeService(kuryedeletedata.id, token));
        }
        else {
            setError(true);
        }
    }

    let PageRedirect = null
    if (deletekuryestatus) {
        PageRedirect = <Redirect to="/kurye-listesi" />
    }

    return (
        <div>
            <Header />
            <div class="wrapper">
                <div class="container-fluid">
                    {PageRedirect}
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <div class="page-title-right">
                                    <ol class="breadcrumb m-0">
                                        <li class="breadcrumb-item"><a href="javascript: void(0);">Aninda Bi'Kurye</a></li>
                                        <li class="breadcrumb-item"><a href="javascript: void(0);"> Kurye Sil</a></li>
                                        <li class="breadcrumb-item active"> Kurye Sil</li>
                                    </ol>
                                </div>
                                <h4 class="page-title"></h4>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="card-box">
                                <h4 class="m-t-0 header-title"> Kurye Sil</h4>
                                <p class="text-muted mb-4 font-14">
                                </p>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="p-2">
                                            <form class="form-horizontal" role="form" onSubmit={handleSubmit} >
                                                <div class="form-group row">
                                                    <label class="col-sm-2  col-form-label" for="simpleinput">Adi</label>
                                                    <div class="col-sm-10">
                                                        <input type="text" id="simpleinput" value={name} class="form-control" onChange={handleName} readOnly placeholder="kurye adı" />
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-sm-2  col-form-label" for="simpleinput">Soyadi</label>
                                                    <div class="col-sm-10">
                                                        <input type="text" id="simpleinput" value={surname} class="form-control" onChange={handleSurname} readOnly placeholder="kurye soyadı" />
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-sm-2  col-form-label" for="simpleinput">Cuzdan</label>
                                                    <div class="col-sm-10">
                                                        <input type="text" id="simpleinput" value={cuzdan} class="form-control" onChange={handleCuzdan} readOnly placeholder='Kurye Cuzdan' />
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-sm-2  col-form-label" for="simpleinput">Sehir</label>
                                                    <div class="col-sm-10">
                                                    <select  value={sehir} onChange={handleSehir} class="form-control">
                                                    <option disabled value="null">Sehir seç</option>
                                                        <option disabled value="Izmir">Izmir</option>
                                                        <option disabled value="Istanbul">Istanbul</option>
                                                    </select>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-sm-2  col-form-label" for="simpleinput">Telefon</label>
                                                    <div class="col-sm-10">
                                                        <input type="text" id="simpleinput" value={tel} class="form-control" onChange={handleTel} readOnly placeholder='05...' />
                                                    </div>
                                                </div>
                                                {
                                                    error ?
                                                        <div class="form-group row">
                                                            <label class="col-sm-2  col-form-label" for="simpleinput"></label>
                                                            <div class="col-sm-10">
                                                                <p style={{ color: 'red' }}>Bilgilerinizi kontrol edin lütfen!</p>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                <div class="form-group row">
                                                    <label class="col-sm-2  col-form-label" for="simpleinput"></label>
                                                    {loading ? <div class="col-sm-10">
                                                        <Loader />
                                                    </div>
                                                        :
                                                        <div class="col-sm-10">
                                                            <button type="submit" class="btn btn-primary">Sil</button>
                                                            <Link to='/kurye-listesi' class="btn btn-success" style={{ marginLeft: 10, color: 'white' }}>Geri don</Link>
                                                        </div>
                                                    }
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
};

export default DeleteKurye